import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import TaskOne from './TaskOne';
import CourseHeader from '../CourseHeader';
import HighlightedList from '../HighlightedList';
import { ReactComponent as Image008 } from '../../images/OP_symbolikuvitus_128_008.svg';
import { ReactComponent as ImageRefund } from '../../images/symbol_developer_corporate_refund_API_128.svg';
import { ReactComponent as Image142 } from '../../images/OP_symbolikuvitus_96_142.svg';
import TextComponent from '../TextComponent';
import TaxesSection from './TaxesSection';
import StockSection from './StockSection';
import CourseComplete from '../CourseComplete';

const Course9 = (): ReactElement => {
  return (
    <div style={{ marginBottom: space.default }}>
      <CourseHeader
        courseTitleId="course9.title"
        courseHeaderText="learn_more"
        Image={ImageRefund}
        courseNumber={9}
      />
      <TaxesSection />
      <StockSection />
      <TaskOne />
      <Image008 className="investoracademy-small-svg" aria-hidden="true" />
      <h2 className="investoracademy-title-hero">
        <Message id="course9.deductions.title" />
      </h2>
      <TextComponent messageId="course9.deductions.body" twoColumns />
      <Image142 className="investoracademy-small-svg" aria-hidden="true" />
      <h2 className="investoracademy-title-hero">
        <Message id="course9.taxfree.title" />
      </h2>
      <TextComponent messageId="course9.taxfree.body" twoColumns />
      <HighlightedList
        title="course9.highlighted_message.title"
        messageId="course9.highlighted_message.body"
      />
      <CourseComplete messageId="course9.recap" />
    </div>
  );
};

export default Course9;
